export function createIndividualEntityRegisteredName(fio: string): string {
    return `ИП ${fio}`;
}
